
import hasPermission from '../globalFunctions/hasPermission';

export default {
  path: '/tradutorDB',
  component: () => import('modules/tradutorDB/Index.vue'),
  children: [
    {
      path: '',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'SIGTIM',
            name: 'Sigtim'
          },
          {
            text: 'Tradutor DB',
            name: 'TradutorDB'
          }
        ]
      },
      name: 'TradutorDB',
      component: () => import('modules/tradutorDB/TradutorDB.vue'),
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.sigtim.de_para')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: '/criar-tradutor-de-para',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Tradutor DB',
            name: 'TradutorDB'
          },
          {
            text: 'Criar DB',
            name: 'criarTradutorDB'
          }
        ]
      },
      name: 'criarTradutorDB',
      component: () => import('../modules/tradutorDB/CreateTradutorDB.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.sigtim.de_para')) {
          next();
        } else {
          next('/');
        }
      }
    }
  ]
};
